import { render, staticRenderFns } from "./SelectShipment.vue?vue&type=template&id=078ba9fd"
import script from "./SelectShipment.vue?vue&type=script&lang=js"
export * from "./SelectShipment.vue?vue&type=script&lang=js"
import style0 from "./SelectShipment.vue?vue&type=style&index=0&id=078ba9fd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports